import lowerCase from "lodash/lowerCase"
import startCase from "lodash/startCase"
import { countries } from "../../../constants/countries"
import { languages } from "../../../utils/languages"

type CountryOption = {
  label: string
  value: string
  code: string
}

type LanguageOption = {
  label: string
  value: string
  code: string
}

export const getBillingCountryOptions = (): CountryOption[] => {
  const countryByCode = new Map<string, CountryOption>()
  countries.forEach((country) => {
    countryByCode.set(country.countryCode, {
      label: country.countryName,
      value: country.countryName,
      code: country.countryCode,
    })
  })
  return Array.from(countryByCode.values())
}

export const getBillingLanguageOptions = (): LanguageOption[] => {
  const languageByCode = new Map<string, LanguageOption>()
  languages.forEach((lang) => {
    languageByCode.set(lang.iso639Code, {
      label: startCase(lowerCase(lang.languageNameNative)),
      value: lang.languageNameShort.toLowerCase(),
      code: lang.iso639Code,
    })
  })
  return Array.from(languageByCode.values())
}
